import { Popover, StatusIndicator } from "@amzn/awsui-components-react";
import { ReactNode } from "react";

interface InfoPopoverProps {
  content: ReactNode;
  children?: ReactNode;
}

export const InfoPopover = ({ content, children }: InfoPopoverProps) => {
  return (
    <Popover
      dismissButton={false}
      position="top"
      size="small"
      triggerType="custom"
      content={content}
    >
      {children ?? <StatusIndicator type="info" />}
    </Popover>
  );
};
